var map = {
	"./arrow.svg": 73,
	"./blockchain-icon.svg": 90,
	"./comprehensive-icon.svg": 473,
	"./finance-icon.svg": 208,
	"./home-bg.png": 470,
	"./logo-108.png": 719,
	"./logo.png": 338,
	"./menu.svg": 17,
	"./mouse.svg": 225
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;